/**
 * Caricamento Dinamico Prodotti per Shopify - INFINITE SCROLL
 * Carica automaticamente i prodotti quando l'utente scrolla verso il basso
 */

class DynamicProductLoader {
  constructor(options = {}) {
    this.container = document.querySelector(options.container || '[data-products-container]');
    this.loadMoreBtn = document.querySelector(options.loadMoreBtn || '[data-load-more]');
    this.paginationContainer = document.querySelector(options.pagination || '.pagination-container');
    this.mode = 'scroll'; // INFINITE SCROLL ATTIVO
    
    // Rileva se siamo su mobile
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 768;
    
    // Usa threshold più alto su mobile
    if (this.isMobile) {
      this.threshold = options.thresholdMobile || 1200; // Molto più alto su mobile
      console.log('📱 Dispositivo mobile rilevato - threshold:', this.threshold);
    } else {
      this.threshold = options.threshold || 800; // Desktop
      console.log('💻 Desktop rilevato - threshold:', this.threshold);
    }
    
    if (!this.container) {
      console.error('❌ Container prodotti NON trovato! Assicurati di aver aggiunto data-products-container alla griglia.');
      return;
    }

    console.log('✅ Caricamento dinamico inizializzato in modalità INFINITE SCROLL');
    console.log('📦 Container trovato:', this.container);
    
    this.nextUrl = this.getNextUrl();
    this.loading = false;
    
    if (!this.nextUrl) {
      console.log('ℹ️ Nessuna pagina successiva trovata (probabilmente c\'è solo 1 pagina)');
    } else {
      console.log('✅ Prossima pagina trovata:', this.nextUrl);
    }
    
    this.init();
  }

  init() {
    // Nascondi la paginazione classica
    if (this.paginationContainer) {
      this.paginationContainer.style.display = 'none';
      console.log('✅ Paginazione classica nascosta');
    }

    // Nascondi il bottone se presente (usiamo scroll infinito)
    if (this.loadMoreBtn) {
      this.loadMoreBtn.style.display = 'none';
    }

    this.initScrollMode();
  }

  getNextUrl() {
    // Cerca prima il link standard con rel="next"
    let nextLink = document.querySelector('.pagination a[rel="next"]');
    
    // Se non trova, cerca il link con la classe pagination__link
    if (!nextLink) {
      console.log('🔍 Link rel="next" non trovato, cerco pagination__link...');
      
      // Trova la pagina corrente dall'URL
      const urlParams = new URLSearchParams(window.location.search);
      const currentPage = parseInt(urlParams.get('page')) || 1;
      const nextPage = currentPage + 1;
      
      console.log('📄 Pagina corrente:', currentPage, '→ Cerco pagina:', nextPage);
      
      // Cerca il link alla pagina successiva
      const allLinks = document.querySelectorAll('.pagination__link, .pagination-row a');
      console.log('🔗 Link paginazione trovati:', allLinks.length);
      
      for (let link of allLinks) {
        const href = link.getAttribute('href');
        console.log('  Controllo link:', href);
        if (href && (href.includes(`?page=${nextPage}`) || href.includes(`&page=${nextPage}`))) {
          nextLink = link;
          console.log('✅ Trovato link pagina successiva!');
          break;
        }
      }
    }
    
    return nextLink ? nextLink.href : null;
  }

  initScrollMode() {
    if (!this.nextUrl) return;

    console.log('🔄 Infinite scroll attivo');

    let scrollTimeout;
    window.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        if (this.shouldLoadMore() && !this.loading) {
          console.log('📜 Caricamento nuovi prodotti...');
          this.loadMoreProducts();
        }
      }, 100);
    });
  }

  shouldLoadMore() {
    const scrollPosition = window.innerHeight + window.scrollY;
    const pageHeight = document.documentElement.scrollHeight;
    const distanceFromBottom = pageHeight - scrollPosition;
    
    // Log solo ogni 500ms circa per non intasare la console
    if (!this._lastLogTime || Date.now() - this._lastLogTime > 500) {
      console.log('📏 Distanza dal fondo:', Math.round(distanceFromBottom) + 'px', '(threshold:', this.threshold + 'px)');
      this._lastLogTime = Date.now();
    }
    
    return distanceFromBottom < this.threshold;
  }

  async loadMoreProducts() {
    if (this.loading || !this.nextUrl) return;

    this.loading = true;
    this.showLoading();

    try {
      console.log('🌐 Fetch da:', this.nextUrl);
      const response = await fetch(this.nextUrl);
      if (!response.ok) throw new Error('Errore nel caricamento');

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Estrai i nuovi prodotti
      const newProducts = doc.querySelectorAll('[data-products-container] > *');
      
      console.log('📦 Nuovi prodotti trovati:', newProducts.length);

      if (newProducts.length > 0) {
        // Aggiungi i nuovi prodotti al container
        newProducts.forEach(product => {
          this.container.appendChild(product.cloneNode(true));
        });

        // Animazione fade-in per i nuovi prodotti
        this.animateNewProducts(newProducts.length);

        // Aggiorna l'URL per la prossima pagina
        // Cerca prima il link standard con rel="next"
        let nextLink = doc.querySelector('.pagination a[rel="next"]');
        
        // Se non trova, cerca il link con la classe pagination__link
        if (!nextLink) {
          const urlParams = new URLSearchParams(new URL(this.nextUrl).search);
          const currentPage = parseInt(urlParams.get('page')) || 1;
          const nextPage = currentPage + 1;
          
          const allLinks = doc.querySelectorAll('.pagination__link, .pagination-row a');
          for (let link of allLinks) {
            const href = link.getAttribute('href');
            if (href && (href.includes(`?page=${nextPage}`) || href.includes(`&page=${nextPage}`))) {
              nextLink = link;
              break;
            }
          }
        }
        
        this.nextUrl = nextLink ? nextLink.href : null;

        console.log('✅ Prodotti caricati con successo');

        // Se non ci sono più pagine
        if (!this.nextUrl) {
          console.log('ℹ️ Nessuna altra pagina disponibile');
          this.showEndMessage();
        } else {
          console.log('➡️ Prossima pagina:', this.nextUrl);
        }

        // Trigger evento personalizzato per altri script
        this.container.dispatchEvent(new CustomEvent('productsLoaded', {
          detail: { count: newProducts.length }
        }));

      } else {
        console.log('⚠️ Nessun prodotto trovato nella risposta');
        this.nextUrl = null;
      }

    } catch (error) {
      console.error('❌ Errore nel caricamento dei prodotti:', error);
      this.showError();
    } finally {
      this.loading = false;
      this.hideLoading();
    }
  }

  showLoading() {
    // Mostra loader per infinite scroll
    const loader = document.createElement('div');
    loader.className = 'products-loader';
    loader.innerHTML = '<span class="spinner"></span> Caricamento prodotti...';
    loader.setAttribute('data-loader', '');
    this.container.parentElement.appendChild(loader);
    console.log('⏳ Loader mostrato');
  }

  hideLoading() {
    const loader = document.querySelector('[data-loader]');
    if (loader) {
      loader.remove();
      console.log('✅ Loader nascosto');
    }
  }

  showEndMessage() {
    const message = document.createElement('div');
    message.className = 'products-end-message';
    message.textContent = 'Non ci sono altri prodotti da visualizzare';
    this.container.parentElement.appendChild(message);
    console.log('✅ Messaggio fine prodotti mostrato');
  }

  showError() {
    const error = document.createElement('div');
    error.className = 'products-error';
    error.textContent = 'Errore nel caricamento dei prodotti. Riprova più tardi.';
    this.container.parentElement.appendChild(error);
    console.log('❌ Messaggio errore mostrato');
  }

  animateNewProducts(count) {
    const allProducts = this.container.children;
    const startIndex = allProducts.length - count;
    
    for (let i = startIndex; i < allProducts.length; i++) {
      const product = allProducts[i];
      product.style.opacity = '0';
      product.style.transform = 'translateY(20px)';
      
      setTimeout(() => {
        product.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
        product.style.opacity = '1';
        product.style.transform = 'translateY(0)';
      }, (i - startIndex) * 50);
    }
  }
}

// Inizializzazione automatica quando il DOM è pronto
document.addEventListener('DOMContentLoaded', () => {
  console.log('🚀 Inizializzazione Caricamento Dinamico Prodotti...');
  
  new DynamicProductLoader({
    container: '[data-products-container]',
    pagination: '.pagination-container',
    mode: 'scroll',
    threshold: 800,        // Desktop: carica a 800px dal fondo
    thresholdMobile: 3000  // Mobile: carica a 3000px dal fondo (prima)
  });
});